import React from "react";
import { ExternalLink } from "react-feather";
import Modal from "../modal/Modal";
import PdfPreview from "./PdfPreview";

/**
 * Réplica do release-note-pdf-modal.tsx do Omnyve.CPU.UI.
 * Abre o PDF inteiro em tela cheia, com o título/versão e o botão
 * "Abrir nova aba".
 */
const ReleaseNotePdfModal = ({ open, releaseNote, fileUrl, onClose }) => {
  const handleOpenNewTab = () => {
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <Modal
      show={open}
      toggle={onClose}
      size="xl"
      position="center"
      className="release-note-pdf-modal"
    >
      <Modal.Header>
        <div className="release-note-pdf-modal-header">
          <div className="release-note-pdf-modal-title">
            <span className="title">{releaseNote.title}</span>
            <span className="version">v - {releaseNote.version}</span>
          </div>
          <button
            type="button"
            className="rn-btn rn-btn-ghost"
            onClick={handleOpenNewTab}
          >
            <ExternalLink size={14} />
            Abrir nova aba
          </button>
        </div>
      </Modal.Header>
      <Modal.Content disableScroll className="release-note-pdf-modal-content">
        <PdfPreview fileUrl={fileUrl} />
      </Modal.Content>
    </Modal>
  );
};

export default ReleaseNotePdfModal;
